export const isPhone = (screen) => {
    return (screen.width >= 320 && screen.width < 767) || (window.innerWidth >= 320 && window.innerWidth < 767);
}

export const isTablet = (screen) => {
    return (screen.width <= 1112 && screen.width >= 767) || (window.innerWidth <= 1112 && window.innerWidth >= 767);
}